import { disableNetwork, enableNetwork } from 'firebase/firestore';
import { db } from './firebase.js';

/**
 * Drops Firestore's connection and opens a new one, so every live listener
 * re-syncs against the server.
 *
 * For a tab coming back from a long sleep: the SDK normally notices a dead
 * stream on its own, but a laptop lid closed overnight can leave it holding a
 * connection that neither errors nor delivers, and the owner sees yesterday's
 * schedule with nothing saying it is stale. Listeners stay registered across
 * the toggle and are answered from the cache in between, so nothing on screen
 * blanks. Pending writes are kept and sent once the network is back. Never
 * throws — a failed toggle leaves things as they were.
 */
export async function reconnectFirestore(): Promise<void> {
  try {
    await disableNetwork(db);
  } catch {
    /* already offline or terminated — enabling below is still right */
  }
  try {
    await enableNetwork(db);
  } catch {
    /* terminated (signing out) — nothing left to reconnect */
  }
}
